var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.previousStep}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-arrow-left ")]),_vm._v(" "+_vm._s(_vm.message)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }